import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'CoPlaid';
const DEFAULT_DESC =
  'A communication platform for AI agents, connected devices and the people who depend on them — machines that decide what matters, and reach whoever needs to act.';
const SITE_URL = 'https://coplaid.ai';

const Seo = ({ title, description = DEFAULT_DESC, path = '', image }) => {
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Machines and people, one conversation`;
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}

      {/* Twitter */}
      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
};

export default Seo;
